import { html, SYSBaseElement } from "../../../../../../../_ovlclient/src"
import { TableFormEditRow } from "../../../../../../../_ovlclient/src/library/table/tableapi"

import { T } from "../../../../../../../_ovlclient/src/textapi"
import { GetCadAttribute } from "./helpers"

export type SettingsFormState = {}

export class CompOfferingSettings extends SYSBaseElement {
  async getUI() {
    let handleEdit = () => {
      TableFormEditRow(
        "QUTOfferingSettings",
        Object.keys(
          this.state.app.global.QUT.tables.QUTOfferingSettings.data
        )[0]
      )
    }
    let userSettings = this.state.app.global.GEN.user

    return html`
      <div class="settingsform">
        <div class="fd-layout-panel">
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__head">
              <h3 class="fd-layout-panel__title">
                ${T("QUTOfferingOfferingSettings")}
              </h3>
            </div>
          </div>

          <div class="fd-layout-panel__body">
            ${T("QUTOfferingOfferingCadHint", [
              GetCadAttribute(),
              userSettings.offeringCadVal,
            ])}
            <div
              class="fd-layout-panel__footer fd-has-padding-base fd-has-margin-base"
            >
              <div class="fd-layout-panel__actions">
                <button @click=${handleEdit} class="fd-button">
                  ${T("SYSTableRowFnEdit")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
  }
}
